import { useContextState } from '../../hooks/theme'

const useStyles = () => {
  const { colors } = useContextState()

  return {
    padding: {
      padding: '10px',
    },
    fontAwesome: {
      padding: '3px',
    },
    labelContainer: {
      display: 'flex',
      justifyContent: 'space-between'
      /* flexDirection: 'column',
      marginBottom: 1 */
    },
    container: {
      display: 'flex',
      flexDirection: 'column',
      flexWrap: 'wrap',
      gap: '20px',
      alignItems: 'center',
      width: 'max-content',
      maxWidth: '220px',
      borderRadius: '5px',
      overflow: 'hidden',
      height: 'fit-content',
      zIndex: 10000,
      background: colors.color5,
      position: 'absolute'
    },
    containerTooltip: {
      //alignItems: 'center',
      //width: 'max-content',
      //border: '1px solid red',
      //maxWidth: '400px',
      width: '400px',
      borderRadius: '5px',
      overflow: 'hidden',
      height: 'fit-content',
      zIndex: 10000,
      background: colors.color5,
      position: 'absolute',
      top: '-30px',
      left: '30px'
    },
    containericon: {
      display: 'flex',
      alignItems: 'center',
      gap: 2,
      justifyContent: 'space-between',
      position: 'relative'
    },
    lastDate: {
      fontSize: '10px',
      width: '100%',
      paddingLeft: '10px',
      paddingTop: '5px',
      color: colors.color20,
    },
    fullName: {
      fontSize: '14px',
      fontWeight: '600',
      width: '100%',
      color: colors.color20,
      marginBottom: '10px',
    },
    detail: {
      fontSize: '10px',
      fontWeight: '500',
      width: '100%',
      color: colors.color20,
      display: 'flex',
      alignItems: 'center',
      wordBreak: 'break-word',
      gap: '5px',
      marginBottom: '5px',
    },
    icon: {
      color: colors.color5,
      background: colors.color2,
      padding: '5px',
      borderRadius: '50%',
      fontSize: '11px',
      width: '22px',
      height: '22px',
      '& .MuiSvgIcon-root': {
        fontSize: '1em',
      },
    },
    img: {
      width: '100%',
      height: '100px',
      padding: '10px',
      '& img': {
        width: '100%',
        height: '100%',
        borderRadius: '5px',
        objectFit: 'cover',
      },
    },
    floatImg: {
      position: 'absolute',
      top: '0',
      userSelect: 'none',
      transform: 'translate(-0%, -170%)',
      zIndex: '0',
      '&:hover': {
        zIndex: 1,
      },
      width: '50px',
      height: '50px',
      '&::before': {
        content: "''",
        width: '3px',
        height: '30px',
        background: colors.color2,
        position: 'absolute',
        top: '-8px',
        left: '50%',
        transform: 'translate(0px, 58px)',
      },
      '& img': {
        border: `2px solid ${colors.color2}`,
        width: '50px',
        height: '50px',
        borderRadius: '50%',
        objectFit: 'cover',
      },
    },
    userPoint: {
      display: 'flex',
      flexWrap: 'wrap',
      flexDirection: 'column',
      alignItems: 'center',
      gap: '10px',
      zIndex: 1,
    },
    location: {
      color: colors.color2,
      fontSize: '40px',
      '& .MuiSvgIcon-root': {
        fontSize: '1em',
      },
    },
    background: {
      background: colors.color5,
      width: '100%',
      height: '100%',
    },

    flex: {
      display: 'flex',
      flexDirection: 'column',
      gap: 1
    },
    relative: {
      position: 'relative'
    },
    titles: {
      marginTop: 2,
      paddingBottom: 1,
      borderBottom: `1px solid ${colors.color13}`
    },
    titlePoint: (flag: boolean) => ({
      color: flag ? colors.color19 : ''
    }),
    error: {
      alignItems: 'center',
      display: 'flex',
      color: colors.color19,
      gap: '3px',
      '& .MuiSvgIcon-root': {
        fontSize: '1rem'
      },
    },
    mapLink: {
      cursor: 'pointer',
      //color: 'primary.main',
      textDecoration: 'underline',
      '& .MuiSvgIcon-root': {
        fontSize: 'inherit',
        verticalAlign: 'middle',
        display: 'inline-block',
        mr: 0.5,
        color: 'primary.main',
      },
      '&:hover': {
        color: 'primary.dark',
        '& .MuiSvgIcon-root': {
          color: 'primary.dark',
        },
      },
    },
    seeMoreContainer: {
      display:'flex',
      gap: '4px'
    }
  }
}

export { useStyles }